module.exports = __webpack_public_path__ + "static/media/KN.a0260af0.svg";